import { Box, styled } from '@mui/material';
import iceberg from '../../assets/iceberg.png';
import papaya from '../../assets/papaya.png';
export const Papaya = styled(Box) `
  position: fixed;
  bottom: 0;
  right: 0;

  height: 25%;
  width: 15%;

  background-image: url('${iceberg}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
  pointer-events: none;
`;
export const IcebergPapaya = styled(Box) `
  position: fixed;
  bottom: 0;
  right: 0;

  height: 25%;
  width: 15%;

  background-image: url('${iceberg}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
  pointer-events: none;
`;
export const PapayaContained = styled(Box) `
  position: absolute;
  bottom: 0;
  right: 0;

  height: 50%;
  width: 30%;

  background-image: url('${papaya}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
  pointer-events: none;
`;
export const IcebergPapayaContained = styled(Box) `
  position: absolute;
  bottom: 0;
  right: 0;

  height: 50%;
  width: 30%;

  background-image: url('${iceberg}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom right;
  pointer-events: none;
`;
export default Papaya;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFwYXlhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY29tbW9uL1BhcGF5YS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFDNUMsT0FBTyxPQUFPLE1BQU0sMEJBQTBCLENBQUM7QUFDL0MsT0FBTyxNQUFNLE1BQU0seUJBQXlCLENBQUM7QUFFN0MsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUE4QixNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7Ozs7Ozs7OzJCQVFqQyxPQUFPOzs7OztDQUtqQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUE4QixNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7Ozs7Ozs7OzJCQVF4QyxPQUFPOzs7OztDQUtqQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUE4QixNQUFNLENBQUMsR0FBRyxDQUFDLENBQUE7Ozs7Ozs7OzJCQVExQyxNQUFNOzs7OztDQUtoQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQThCLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTs7Ozs7Ozs7MkJBUWpELE9BQU87Ozs7O0NBS2pDLENBQUM7QUFDRixlQUFlLE1BQU0sQ0FBQyJ9